import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { getParams, getDobFromPin } from '../../common/utils';
import { isEqual } from 'lodash';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { MomentDate } from '../../common/momentComponent';
import { searchActions, searchStatus, cuzkSearchType } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import BbPopover from '../../common/popover';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import PropertyCzCadastreUnit from './propertyCzCadastreUnit';
import BasicRow from '../../reportSections/identData/basicRow';

import SvgZamcene from '../../../img/icons/Zamcene';
import SvgRefresh from "../../../img/icons/Refresh";

import './propertyCz.scss';

class PropertyCzReport extends React.Component {
    componentDidMount() {
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = getParams(window.location.search);
            this.props.cuzkSearchOwnership(params);
        }
    }

    componentDidUpdate() {
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = getParams(window.location.search);
            const stateParams = this.getSearchResult("params");
            if (!isEqual(stateParams, params))
                this.props.cuzkSearchOwnership(params);
        }
    }

    render() {
        const data = this.getSearchResult("data");
        const params = this.getSearchResult("params") || {};
        const error = this.getSearchResult("error");

        if (this.getSearchResult("status") === searchStatus.requested)
            return <Circles />;

        if (!isNullOrUndefined(data) && !isNullOrUndefined(data.exception)) {
            return (
                <div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type={data.exceptionLevel || "error"} options={{ renderInnerHtml: true }}
                        message={this.props.translate(data.exception, isNullOrUndefined(data.exceptionData) ? undefined : data.exceptionData)}
                    />
                </div>
            );
        }

        if (isNullOrUndefined(data))
            return <NoDataComponent />;

        return (
            <>
                {!isNullOrUndefined(error) && <div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type="error" options={{ renderInnerHtml: true }} message={this.props.translate(error)} />
                </div>}
                {this.renderReportDateInformation(data)}
                <div className='card'>
                    <div className='card-body'>
                        <div className="ident-data">
                            {(!isNullOrUndefined(data.pin) || !isNullOrUndefined(params.pin)) && params.pin !== 'undefined' &&
                                <BasicRow title="PropertyCz.Search.Pin" value={isNullOrUndefined(data.pin) ? params.pin : data.pin} />}
                            {!isNullOrUndefined(params.companyId) && <BasicRow title="PropertyCz.Search.CompanyId" value={params.companyId} />}
                            {!isNullOrUndefined(data.companyName) && <BasicRow title="PropertyCz.Search.Name" value={data.companyName} />}
                            {!isNullOrUndefined(data.name) && <BasicRow title="PropertyCz.Search.Name" value={data.name} />}
                            {this.renderDobRow()}
                            {!isNullOrUndefined(params.dataDate) &&
                                <BasicRow title="PropertyCz.Search.DataDate" value={<MomentDate value={params.dataDate} />} />}
                            {<BasicRow title="PropertyCz.Report.CadastreUnitsCount" value={data.cadastreUnitsCount} />}
                            {<BasicRow title="PropertyCz.Report.OwnershipDocumentsCount" value={data.ownershipDocumentsCount} />}
                        </div>
                        {!isNullOrUndefined(data.cadastreUnits) && !isNullOrUndefined(data.cadastreUnits.items) && this.renderCadastralUnitsOverview(data, params.dataDate)}
                    </div>
                </div>
                <div className="disclaimer-wrapper">
                    <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                    <hr style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                    <div className="disclaimer-gray"><Translate id="PropertyCz.Disclaimer" /></div>
                </div>
            </>
        )
    }

    renderReportDateInformation(data) {
        return (
            <div className="cuzk-query-date">
                <div>
                    <span className="bold"><Translate id="PropertyCz.Inserted" />: </span>
                    <span className="bold">{data.insertedFormated}</span>
                </div>
                <div>
                    <span className="bold"><Translate id="PropertyCz.Completed" />: </span>
                    <span className="bold">{data.completedFormated}</span>
                </div>
            </div>
        );
    }

    renderDobRow = () => {
        const data = this.getSearchResult("data");
        const params = this.getSearchResult("params") || {};
        if (!isNullOrUndefined(data) && !isNullOrUndefined(data.dob)) {
            return !isNullOrUndefined(data.dobPartner)
                ? <BasicRow title="PropertyCz.Search.BirthDate" value={<>{data.dobFormated}, {data.dobPartnerFormated}</>} />
                : <BasicRow title="PropertyCz.Search.BirthDate" value={data.dobFormated} />;
        }

        const dob = getDobFromPin(params.pin);
        if (!isNullOrUndefined(params.pin) && !isNullOrUndefined(dob))
            return <BasicRow title="PropertyCz.Search.BirthDate" value={<MomentDate value={dob} />} />;
    }

    renderCadastralUnitsOverview = (data, dataDate) => {
        return (
            <div className="cuzk-oo-wrapper">
                <div className="cuzk-available">
                    <div className="cuzk-column">
                        {isNullOrUndefined(dataDate) && <BbPopover
                            content={this.props.translate("PropertyCz.Report.CU.UpdateDataPopover")}
                            placement="top"
                            targetId="cuzk-available-cu-link"
                            toggleOnEvent="toggleOnMouse"
                        >
                            <div id="cuzk-available-cu-link">
                                <SvgRefresh className="refresh-icon" />
                                <div className="link-internal" onClick={() => this.updateData()}>
                                    <Translate id="PropertyCz.Report.CU.UpdateData" /><SvgZamcene />
                                </div>
                            </div>
                        </BbPopover>}
                    </div>
                    <span className='cuzk-column underlined-title-wrapper' style={{ margin: "1em 0" }}>
                        <span className='underlined-title'><Translate id="PropertyCz.Report.CadastreUnitsOverview" /></span>
                    </span>
                    <div className="cuzk-column" />
                </div>
                <OldStyleTableWithHistory
                    colWidths={data.anyRestrictions ? ['', '8%', '', '8%', '20%', '8%', '20%', '8%'] : ['', '9%', '', '9%', '22%', '9%', '21%']}
                    colWidthsOnMobile={false}
                    head={() => <thead>
                        <tr>
                            <th style={{ width: '4em' }} />
                            <th><Translate id="PropertyCz.Report.CU.CadastreUnitId" /></th>
                            <th style={{ width: '7.5em' }}><Translate id="PropertyCz.Report.CU.CadastreUnitName" /></th>
                            <th><Translate id="PropertyCz.Report.CU.MunicipalityId" /></th>
                            <th><Translate id="PropertyCz.Report.CU.MunicipalityName" /></th>
                            <th><Translate id="PropertyCz.Report.CU.DistrictId" /></th>
                            <th style={{ width: '6.5em' }}><Translate id="PropertyCz.Report.CU.DistrictName" /></th>
                            {data.anyRestrictions && <th><Translate id="PropertyCz.Report.OD.Restriction" /></th>}
                        </tr>
                    </thead>}
                    actualData={data.cadastreUnits.items} fixed classNames='old-style-bordered'
                    actualRow={i => <PropertyCzCadastreUnit data={i} osId={this.getSearchResult("params").osId}
                        key={i.cadastreUnitId} showRestrictions={data.anyRestrictions} />}
                />
            </div>
        );
    }

    updateData = () => {
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = getParams(window.location.search);
            this.props.cuzkUpdateOwnershipData(params);
        }
    }

    getSearchResult = (field) => {
        return (isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search[cuzkSearchType.report]))
            ? null : this.props.search[cuzkSearchType.report][field];
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.cuzk } }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(PropertyCzReport)));
